<template>
  <ul class="dropdown-menu dropdown-submenu-left">
    <li v-for="item in menu" :key="item.label">
      <template v-if="item.subitens">
        <a class="nav-link">
          <span class="ms-3">
            {{ item.label }}
            <font-awesome-icon
              icon="caret-right"
              aria-label="Abre submenu"
              title="Abre submenu"
              style="padding-right: -1em; float: right"
            />
          </span>
        </a>
        <piweb-submenu-item
          class="ms-3"
          :menu="item.subitens"
        ></piweb-submenu-item>
      </template>
      <component
        :is="linkType"
        class="nav-link"
        aria-current="page"
        :to="item.link ? item.link : '/#'"
        :href="item.link ? item.link : '/#'"
        v-else-if="item.label"
      >
        <span class="ms-3">
          {{ item.label }}
        </span>
      </component>
      <hr class="dropdown-divider" v-else />
    </li>
  </ul>
</template>

<script>
import PiwebSubmenuItem from "./piweb-submenu-item.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(faCaretRight);

export default {
  name: "PiwebSubmenuItem",
  components: { PiwebSubmenuItem, FontAwesomeIcon },
  props: {
    menu: {
      type: Array,
      require: true,
    },
  },
  computed: {
    linkType() {
      return this.$router ? "router-link" : "a";
    },
  },
};
</script>

<style>
.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-nav .nav-link:focus,
.navbar-nav .nav-link:hover {
  background-color: #e7e7e7;
}

.dropdown-menu li {
  position: relative;
}

.dropdown-menu .dropdown-submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: -5px;
}

.dropdown-menu .dropdown-submenu-left {
  right: 100%;
  left: auto;
  top: -5px;
}

.dropdown-menu > li:hover > .dropdown-submenu,
.dropdown-menu > li:hover > .dropdown-submenu-left {
  display: block;
}
</style>